package de.oevbs.kunde.kundenportal2.services.registration

import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.forms.inputgroup.inputText
import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import de.oevbs.kunde.kundenportal2.*
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.model.services.registration.RetrieveUser
import de.oevbs.kunde.kundenportal2.model.services.registration.partner
import de.oevbs.kunde.kundenportal2.navigation.visit
import de.oevbs.kunde.kundenportal2.services.registration.store.RetrieveUserStore
import dev.fritz2.core.RenderContext
import dev.fritz2.core.invoke
import dev.fritz2.headless.validation.Severity
import kotlinx.coroutines.flow.combine

fun RenderContext.retrieveUserStart() {
    val retrieveStore = RetrieveUserStore(job)
    GlobalServiceMessagesStore.forceClear()

    headerImageLayout {
        title("Benutzername vergessen?")
        content {
            renderRetrieveUser(retrieveStore)
        }
    }
}

fun RenderContext.retrieveUserContinue() {
    val retrieveStore = RetrieveUserStore(job)
    retrieveStore.setStep(RetrieveUserStep.SHOWUSER3)

    headerImageLayout {
        title("Ihr Benutzername")
        content {
            renderRetrieveUser(retrieveStore)
        }
    }
}

private fun RenderContext.renderRetrieveUser(retrieveStore: RetrieveUserStore) {

    div("sm:w-full xl:w-3/4") { // Angaben werden nur für die schmalen Seiten vor dem Login genutzt

        contentContainer {

            retrieveStore.currentStep.combine(theRouter.data, ::Pair).render { (step, paramsMap) ->

                when (step) {

                    // Schritt 1, Link an Partnereingabe schicken
                    RetrieveUserStep.PARTNER1 -> retrieveUserInputPartner(retrieveStore)

                    // Schritt 2, Link erfolgreich verschickt (Partner gefunden)
                    RetrieveUserStep.PARTNERVALID2 -> {
                        messagePageText(
                            header = "Account wurde gefunden",
                            text = "Wir haben eine Mail an die mit Ihrem Account verknüpfte Adresse verschickt."
                                    + " Bitte klicken Sie auf den Link in der Mail, um Ihren Benutzernamen zu erfahren.",
                        )
                    }

                    // Schritt 3, Link in der Mail wurde geclickt und User wird nun angezeigt
                    RetrieveUserStep.SHOWUSER3 -> {

                        val invalidParam = paramsMap["invalid"]
                        if (invalidParam != null) { // Link ist abgelaufen - Fehler anzeigen und Prozess neu beginnen
                            GlobalServiceMessagesStore.add(PortalMessages.tokenInvalid)
                            Pages.retrieveUser.visit()
                        }
                        val userParam = paramsMap["user"]
                        // Username wurde als URL-Param übergeben: ?user=xxx
                        if (userParam != null) {
                            messagePageText(
                                header = "Ihr Benutzername lautet: $userParam",
                                text = " Sie können sich nun mit Benutzername und Passwort im Kundenportal einloggen.",
                                severity = Severity.Info,
                                buttonLabel = "Weiter zum Login",
                                pageTarget = Pages.root,
                                showRedirectNotice = true
                            )
                        } else {
                            messagePageText(
                                header = "Fehler: Seite ungültig",
                                text = "Die Seite wurde mit ungültigen Parametern aufgerufen. Bitte starten Sie den Prozess erneut.",
                                severity = Severity.Error
                            )
                        }
                    }

                    else -> {
                        console.error("Unbekannter RetrieveUserStep: '${step}'. Zeige Step 1 an.")
                        retrieveUserInputPartner(retrieveStore)
                    }
                }
            }
        }
    }
}

private fun RenderContext.retrieveUserInputPartner(retrieveStore: RetrieveUserStore) {

    paragraph {
        +"Sollten Sie bereits Versicherungsverträge mit Ihrem Account verknüpft haben, können Sie sich Ihren"
        +" Benutzernamen an die im Vertrag hinterlegte Mail-Adresse senden lassen. Bitte geben Sie dazu Ihre Partnernummer ein. "
        inlineLink(
            text = "Diese finden Sie auf Ihren Vertragsdokumenten.",
            link = "https://www.oeffentliche.de/export/sites/oevbs/_resources/downloads/pdf/service/partnernummer-musterbrief.pdf",
            target = "_blank"
        )
    }

    inputText {
        value(retrieveStore.map(RetrieveUser.partner() + Formats.partnerId))
        label("Verknüpfte Partnernummer")
        iconClickableWithPopover(MaterialIconsOutlined.help, HelpPopovers.partnerId)
    }

    buttonContainer {
        btn {
            label("Benutzernamen-Anfrage abschicken")
            busy(globalSubmitTracker.data)
        }.clicks handledBy retrieveStore.handlePartner
    }
}